import { useState, useEffect, useRef } from "react";
import GalleryItem from "../../components/galleryItem";
import Player from "../../player/player-static";
import { useMediaQuery } from "../../utils/useMediaQuery";

import {
  ArrowForwardIosRounded,
  ArrowBackIosRounded,
} from "@mui/icons-material";

const Scroll = ({ data }) => {
  const [error, setError] = useState("");
  const [playerOpen, setPlayerOpen] = useState(false);
  const [itemData, setItemData] = useState({});
  const galleryRef = useRef();

  const gridSize = useMediaQuery({
    default:data.settings.itemsPerRow.s,
    md:data.settings.itemsPerRow.md,
    lg:data.settings.itemsPerRow.lg,
    xl:data.settings.itemsPerRow.xl,
    xxl:data.settings.itemsPerRow.xxl,
  });

  const openPlayer = (item) => {
    setItemData(item);
    setPlayerOpen(true);
  };

  const closePlayer = () => {
    setPlayerOpen(false);
  };

  const scrollNext = () => {
    galleryRef.current.scroll({
      top: 0,
      left: galleryRef.current.scrollLeft + galleryRef.current.clientWidth,
      behavior: "smooth",
    });
  };

  const scrollPrev = () => {
    galleryRef.current.scroll({
      top: 0,
      left: galleryRef.current.scrollLeft - galleryRef.current.clientWidth,
      behavior: "smooth",
    });
  };

 if (error) {
    return (
      <div className="w-full h-full flex justify-center items-center">
        <div className="bg-black/90 p-5 rounded-md">
          <span className="text-white">{error}</span>
        </div>
      </div>
    );
  } else {
    return (
      <div
        id={`widget-${data.id}`}
        className="overflow-y-hidden w-full relative"
      >
        <div
          ref={galleryRef}
          className="vf-gallery overflow-y-hidden overflow-x-auto flex h-full w-full snap-x scrollbar-none"
        >
          {data.content.map((item) => (
            <div key={item.id} className="flex-grow-0 flex-shrink-0 h-full relative" style={{
              flexBasis : `${100/gridSize}%`,
              paddingLeft: `${data.settings.gap/2}px`,
              paddingRight: `${data.settings.gap/2}px`
            }}>
            <GalleryItem
              item={item}
              settings = {data.settings}
              onClick={openPlayer}
            ></GalleryItem>
            </div>
          ))}
        </div>
        <div
          onClick={scrollPrev}
          className="vf-scroll-button z-30 absolute left-3 top-1/2 -translate-y-1/2 bg-black text-white/70 w-12 h-12 bg-black/50 rounded-lg flex justify-center items-center hover:text-white hover:bg-black/90 cursor-pointer"
        >
          <ArrowBackIosRounded fontSize="large" />
        </div>
        <div
          onClick={scrollNext}
          className="vf-scroll-button z-30 absolute right-3 top-1/2 -translate-y-1/2 bg-black text-white/70 w-12 h-12 bg-black/50 rounded-lg flex justify-center items-center hover:text-white hover:bg-black/90 cursor-pointer"
        >
          <ArrowForwardIosRounded fontSize="large" />
        </div>
        {playerOpen && <Player onClose={closePlayer} item={itemData} widget={data.id} settings={data.settings}/>}
      </div>
    );
  }
};

export default Scroll;
